<template>
  <PC v-if="isPC"></PC>
  <Mobile v-else></Mobile>
</template>
<script>
import PC from './components/pc.vue'
import Mobile from './components/mobile.vue'
export default {
  name: 'app',
  components: {
    PC,
    Mobile
  },
  data() {
    return {
      isPC: true
    }
  },
  created() {
    this.isPC = window.innerWidth > 600
    // 监听窗口宽度变化
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.isPC = window.innerWidth > 600
    }
  }
}
</script>
